/*
  Sale events (SALE-1). Pages are served from Shopify's cache, so a sale can
  outlive its end by some minutes in the HTML. This script reads the end from
  each surface's data-sale-ends (Unix seconds) and hides the surface once that
  moment has passed, checked on load and every 60 s. It also ticks the banner
  countdown and the announcement line's "Ends in". It only ever HIDES or
  updates what Liquid rendered; it never shows anything new.
  One exception (SALE-2): an element carrying data-sale-after is the price the
  product had without the sale, rendered hidden beside the sale price by
  snippets/sale-price; it is revealed when the sale price is hidden.
*/
(function () {
  if (window.SarupSaleEvent) return;
  window.SarupSaleEvent = true;

  function plural(n, one, many) {
    return n + ' ' + (n === 1 ? one : many);
  }

  function tick() {
    var now = Math.floor(Date.now() / 1000);
    document.querySelectorAll('[data-sale-ends]').forEach(function (el) {
      var end = parseInt(el.getAttribute('data-sale-ends'), 10);
      if (!end) return;
      var left = end - now;
      if (left < 0) {
        el.hidden = true;
        el.style.display = 'none';
        return;
      }
      var d = Math.floor(left / 86400);
      var h = Math.floor((left % 86400) / 3600);
      var m = Math.floor((left % 3600) / 60);
      el.querySelectorAll('[data-sale-countdown] [data-cd]').forEach(function (b) {
        var k = b.getAttribute('data-cd');
        b.textContent = k === 'd' ? d : k === 'h' ? h : m;
      });
      el.querySelectorAll('[data-sale-ends-in]').forEach(function (s) {
        s.textContent =
          'Ends in ' + (d > 0 ? plural(d, 'day', 'days') + ' ' + plural(h, 'hr', 'hrs') : plural(h, 'hr', 'hrs') + ' ' + plural(m, 'min', 'mins'));
      });
    });
    var revealed = false;
    document.querySelectorAll('[data-sale-after][hidden]').forEach(function (el) {
      var end = parseInt(el.getAttribute('data-sale-after'), 10);
      if (end && end - now < 0) {
        el.hidden = false;
        revealed = true;
      }
    });
    // The sticky add-to-cart bar copies the visible price only on load and on
    // a variant change (its observer does not see attribute changes); point it
    // at the now-visible price and ask it to copy again, so it drops the sale
    // price too.
    if (revealed) {
      document.querySelectorAll('sticky-atc').forEach(function (bar) {
        if (typeof bar.mirror !== 'function') return;
        bar.priceSource = document.querySelector(bar.dataset.priceSource);
        bar.mirror();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tick);
  } else {
    tick();
  }
  setInterval(tick, 60000);
})();
